// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

/** English UI strings: plans and billing (components/BillingPanel.tsx). Merged into the catalog by messages.en.ts. */
export const billing = {
  "settings.section.billing": "Plan and billing",
  "billing.title": "Plan and billing",
  "billing.workspaceTitle": "{name} workspace",
  "billing.personalDescription": "Your plan, how much space you use, and your payments.",
  "billing.company": "Your account belongs to {workspace}, so it has the workspace's plan for everything, your own vaults included. The workspace pays for it; there is nothing to buy here.",
  "billing.companyOpen": "Open the workspace",
  "billing.workspaceDescription": "Business for this workspace, billed per seat: every member above Guest.",
  "billing.plan.free": "Free plan",
  "billing.plan.named": "{plan} plan",
  "billing.price.monthly": "{price} a month",
  "billing.price.perSeat": "{price} per seat a month",
  "billing.seats": "{count} seats",
  "billing.status.trial": "Free trial until {date}.",
  "billing.status.pastDue": "The last payment did not go through. Everything keeps working until {date}; update your payment method before then.",
  "billing.status.lapsed": "The trial ended on {date}. This workspace now has the Free plan's limits; nothing was deleted. Subscribe to get Business back.",
  "billing.status.renews": "Renews on {date}.",
  "billing.status.proTrial": "Free trial until {date}; then it renews monthly until you cancel.",
  "billing.status.ends": "Ends on {date}; it will not renew.",
  "billing.storage": "Storage",
  "billing.storageUsed": "{used} of {limit} used",
  "billing.storage80": "Storage is almost full. New files stop uploading at 100%.",
  "billing.storage100": "Storage is full: new files no longer upload. Everything stays readable. Free up space or upgrade.",
  "billing.upgradePro": "Upgrade to Pro",
  "billing.startProTrial": "Start free trial",
  "billing.proTrial": "{days} days free, then {price}/month.",
  "billing.proTrialTerms": "A card is needed. Cancel before the trial ends and you pay nothing; otherwise Pro renews monthly until you cancel. One free trial per person.",
  "billing.proPitch": "Pro: 10 synced vaults, 1 GB, files up to 100 MB, 12 months of history, any number of devices, and AI tools over MCP.",
  "billing.subscribeBusiness": "Subscribe to Business",
  "billing.seatsLabel": "Seats",
  "billing.seatsHint": "At least 2, and at least the members above Guest. Seats follow the member count automatically.",
  "billing.manage": "Manage subscription",
  "billing.currentPlan": "Current plan",
  "billing.cards": "Payment methods",
  "billing.cardsHint": "The default card pays your next invoices. Card details are kept by Stripe, never by Granite.",
  "billing.addCard": "Add card",
  "billing.noCards": "No saved cards.",
  "billing.cardEnding": "{brand} ending in {last4}",
  "billing.cardDefault": "Default",
  "billing.cardExpires": "Expires {date}",
  "billing.cardExpired": "Expired {date}",
  "billing.makeDefault": "Make default",
  "billing.remove": "Remove",
  "billing.removeCard": "Remove {card}",
  "billing.invoicesHint": "Receipts for every payment, with a PDF for your records.",
  "billing.invoicePdf": "PDF",
  "billing.invoiceState.paid": "Paid",
  "billing.invoiceState.open": "Due",
  "billing.invoiceState.void": "Void",
  "billing.invoiceState.draft": "Draft",
  "billing.invoiceState.uncollectible": "Unpaid",
  "billing.managedInStore": "This subscription is managed in {store}. Change or cancel it there.",
  "billing.store.app_store": "the App Store",
  "billing.store.google_play": "Google Play",
  "billing.unavailable": "Payments are not available yet.",
  "billing.redirecting": "Opening the payment page…",
  "billing.invoices": "Invoices",
  "billing.invoiceDate": "Date",
  "billing.invoiceNumber": "Number",
  "billing.invoiceTotal": "Total",
  "billing.invoiceStatus": "Status",
  "billing.invoiceOpen": "View",
  "billing.noInvoices": "No invoices yet.",
  "error.subscription_exists": "There is already an active subscription.",
  "error.billing_unavailable": "Payments are not available right now. Try again in a minute.",
  "error.billing_forbidden": "Only the workspace's owner and admins manage its billing.",
  "error.workspace_trial_in_use": "You already have a workspace on its free trial. Subscribe to it before starting another.",
  "error.no_billing_account": "There is no billing account yet.",
  "error.card_needed": "Your subscription is paid with this card. Add another card before removing it.",
  "error.no_such_card": "That card is no longer saved.",
} as const;
